import clsx from "clsx";
import {useEffect, useState} from "react";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function useWindowSize() {
  const [size, setSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  })

  useEffect(() => {
    function onResize() {
      setSize({
        width: window.innerWidth,
        height: window.innerHeight,
      })
    }

    window.addEventListener('resize', onResize)
    return () => window.removeEventListener('resize', onResize)
  }, [])

  return size
}

export function randomString(length) {
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

export const getLogoURL = (logoUrl) => {
  if (!logoUrl) {
    return 'https://res.cloudinary.com/dghqjv5az/image/upload/v1669488290/mix/logossala/logo_xd33n7.png';
  }
  return 'https://res.cloudinary.com/dghqjv5az/image/upload/c_fill,h_120/linkedwgt/' + logoUrl;
};